
jQuery(function(){
	initSelects();
});

function initSelects() {
	$('.select').fastselect();
	$('.select').addClass('select--hidden');
}